export default "__VITE_ASSET__BCSS9yYU__"